import { render, staticRenderFns } from "./PieEChart.vue?vue&type=template&id=62e3d1be&"
import script from "./PieEChart.vue?vue&type=script&lang=js&"
export * from "./PieEChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports